import { getThemePalette } from '../helpers/getPalette';

export const light = getThemePalette('light');
export const highContrast = getThemePalette('high-contrast');
export const dark = getThemePalette('dark');
